import { DATABASE_LARGE_DATA_POLICY } from '@streamlain/database-identity';
import { unzipSync } from 'fflate';

import { ImportLimitError } from './import-limit-error';

const MIB = 1024 * 1024;
const { excelFileHardLimitBytes, excelExpandedHardLimitBytes } =
  DATABASE_LARGE_DATA_POLICY.import;

/** Sum of the declared uncompressed entry sizes, read without inflating. */
export function expandedWorkbookBytes(bytes: Uint8Array): number {
  let total = 0;
  unzipSync(bytes, {
    filter(entry) {
      total += entry.originalSize;
      return false;
    },
  });
  return total;
}

/**
 * Bytes of an Excel workbook the in-memory reader can load. A larger file is
 * refused before it is read, a workbook that expands beyond the budget before
 * it is parsed; both name the CSV import as the way to import it.
 */
export async function readExcelWorkbookBytes(file: File): Promise<ArrayBuffer> {
  if (file.size > excelFileHardLimitBytes)
    throw new ImportLimitError({
      kind: 'excel-file-size',
      actual: Math.ceil(file.size / MIB),
      limit: excelFileHardLimitBytes / MIB,
    });
  const buffer = await file.arrayBuffer();
  const expanded = expandedWorkbookBytes(new Uint8Array(buffer));
  if (expanded > excelExpandedHardLimitBytes)
    throw new ImportLimitError({
      kind: 'excel-expanded-size',
      actual: Math.ceil(expanded / MIB),
      limit: excelExpandedHardLimitBytes / MIB,
    });
  return buffer;
}
